import React, { useEffect, useState } from "react";
import analytics from "web/script/analytics/analytics";
import { connect } from "react-redux";
import { languageIsEnglish } from "web/script/modules/language";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";
import { gettext } from "web/script/modules/django-i18n";
import { ProfileProps } from "web/react/components/profile-header/profile-header";
import CcpaCookieBanner from "web/react/components/ccpa-cookie-banner/ccpa-cookie-banner";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import userProfiler from "web/script/modules/userprofiler";
import withReduxProvider from "web/react/redux-provider";
import styles from "./banner-container.css";

interface BannerContainerReduxStateProps {
    feedProfile: ProfileProps;
    showDUBanner: boolean;
    disableDUBanner: boolean;
}

function mapStateToProps(state): BannerContainerReduxStateProps {
    const {
        profile: feedProfile,
        show,
        bannerDisable: disableDUBanner,
    } = state.followDesignerBannerReducer;

    const showDUBanner = show;

    return { feedProfile, showDUBanner, disableDUBanner };
}

export function BannerContainer({
    feedProfile,
    showDUBanner,
    disableDUBanner,
}: BannerContainerReduxStateProps): JSX.Element {
    const [isIos, setIsIos] = useState(false);
    const pageSubType = environment.get("pageSubType");
    const [showCcpaCookieBanner, setShowCcpaCookieBanner] = useState<boolean>(false);

    useEffect(() => {
        // userProfiler isn't available in Hypernova so just set the flag once mounted
        setShowCcpaCookieBanner(
            environment.get("country") === "US" &&
                !userProfiler.getCcpaCookieBannerDismissed() &&
                pageSubType !== "privacy_policy"
        );
    }, [pageSubType]);

    useEffect(() => {
        setIsIos(browser.ios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browser.ios]);

    const enableIosToApp = environment.getFeature("mg_du_banner_ios_to_app");
    const isOnDesignerFeed = pageSubType && pageSubType.startsWith("designer");
    const sendIOSUsersToApp = isIos && enableIosToApp && isOnDesignerFeed;

    let followButtonProps = feedProfile.follow_button
        ? {
              lystId: feedProfile.follow_button.lyst_id,
              isAuthenticated: feedProfile.follow_button.is_authenticated,
              isFollowing: feedProfile.follow_button.is_following,
              description: sendIOSUsersToApp
                  ? feedProfile.follow_button.ios_sticky_description
                  : "",
              notFollowedText:
                  enableIosToApp && isOnDesignerFeed
                      ? // 'Get Designer Updates'
                        gettext("designer_updates.get_designer_updates_btn_text")
                      : feedProfile.follow_button.notfollowed_text,
              profileImage: feedProfile.small_photo_url,
              followedText: feedProfile.follow_button.followed_text,
              designerName: feedProfile.follow_button.designer_name,
              productTaxonomy: feedProfile.follow_button.product_taxonomy,
          }
        : null;

    function onCcpaCookieBannerClose(): void {
        analytics.event("cookie_banner", "dismissed", "ccpa_banner");
        userProfiler.setCcpaCookieBannerDismissed(true);
        setShowCcpaCookieBanner(false);
    }

    return (
        <div className={styles.container}>
            {languageIsEnglish() &&
                !disableDUBanner &&
                showDUBanner &&
                feedProfile &&
                feedProfile.follow_button &&
                feedProfile.follow_button.is_authenticated != "true" && (
                    <FollowStickyBanner
                        forceDisplay={showDUBanner}
                        downloadApp={!!environment.getFeature("mg_enable_top_and_du_banners")}
                        {...followButtonProps}
                    />
                )}
            {showCcpaCookieBanner && (
                <CcpaCookieBanner onCloseButtonClick={onCcpaCookieBannerClose} />
            )}
        </div>
    );
}

export default withReduxProvider(connect(mapStateToProps)(BannerContainer));
